import React from 'react'
import image1 from '../images/wedding1.jpeg'
import image2 from '../images/wedding2.jpeg'
import image3 from '../images/wedding3.jpeg'
import image4 from '../images/wedding4.jpeg'
import image5 from '../images/wedding5.jpeg'
import image6 from '../images/wedding6.jpeg'
import image7 from '../images/wedding7.jpeg'
import image8 from '../images/wedding8.jpeg'
import image9 from '../images/wedding9.jpeg'
import image10 from '../images/wedding10.jpeg'
import image11 from '../images/wedding11.jpeg'
import image12 from '../images/wedding12.jpeg'
import image13 from '../images/wedding13.jpeg'
import image14 from '../images/wedding14.jpeg'
import image15 from '../images/wedding15.jpeg'
import image16 from '../images/wedding16.jpeg'
import image17 from '../images/wedding17.jpeg'
import image18 from '../images/wedding18.jpeg'


export default function Weddings() {
  return (
    <div className='sub-gallery-images'>
      <img src={image1} alt='photo' className='sub-gallery-image'/>
      <img src={image2} alt='photo' className='sub-gallery-image'/>
      <img src={image3} alt='photo' className='sub-gallery-image'/>
      <img src={image4} alt='photo' className='sub-gallery-image'/>
      <img src={image5} alt='photo' className='sub-gallery-image'/>
      <img src={image6} alt='photo' className='sub-gallery-image'/>
      <img src={image7} alt='photo' className='sub-gallery-image'/>
      <img src={image8} alt='photo' className='sub-gallery-image'/>
      <img src={image9} alt='photo' className='sub-gallery-image'/>
      <img src={image10} alt='photo' className='sub-gallery-image'/>
      <img src={image11} alt='photo' className='sub-gallery-image'/>
      <img src={image12} alt='photo' className='sub-gallery-image'/>
      <img src={image13} alt='photo' className='sub-gallery-image'/>
      <img src={image14} alt='photo' className='sub-gallery-image'/>
      <img src={image15} alt='photo' className='sub-gallery-image'/>
      <img src={image16} alt='photo' className='sub-gallery-image'/>
      <img src={image17} alt='photo' className='sub-gallery-image'/>
      <img src={image18} alt='photo' className='sub-gallery-image'/>
    </div>
  )
}
